import CreditCard from '../CreditCard';
import * as S from './styles';

declare type TwoCreditCardsProps = {
    title?: string;
    frontTheme?: string;
    backTheme?: string;
    frontlabel?: string;
    backLabel?: string;
}

export default function TwoCreditCards({
    title,
    frontTheme,
    backTheme,
    frontlabel,
    backLabel
}: TwoCreditCardsProps) {
    return (
        <S.Container>
            <S.BackCard>
                <CreditCard title={title} theme={backTheme} cardLabel={backLabel}/>
            </S.BackCard>

            <S.FrontCard>
                <CreditCard title={title} theme={frontTheme} cardLabel={frontlabel}/>
            </S.FrontCard>
        </S.Container>
    )
}
